import React from 'react';
import './Dashboard.css';
import MyLineChart from '../MyLineChart/MyLineChart';

const Dashboard = () => {
    return (
        <div>
            <MyLineChart></MyLineChart>
        </div>
    );
};

export default Dashboard;